import axios from '../axios';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './dashboard.css';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  CardText,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ApartmentIcon from '@mui/icons-material/Apartment';
import {
  Dialog,
  LinearProgress,
  Typography,
  CardActions,
  CardContent,
  Box,
  Button,
  Stack,
  Avatar,
  Paper,
  Divider,
  Chip,
  TextField,
  FormControl,
  InputLabel,
  Input,
} from '@mui/material';
import { Zoom } from '@material-ui/core';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import numeral from 'numeral';
import shadows from '@material-ui/core/styles/shadows';
import { Item } from 'semantic-ui-react';
import iconsimage from '../assets/img/others/building.png';
import cnt from '../assets/img/profile.png';
import SweetAlert from 'react-bootstrap-sweetalert';
import MyCalendar from './Calender/MyCalendar';
import DashboardOld from './Dashboard';

function Dashboard() {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );
  const [openLoader, setOpenLoader] = useState(false);

  const [ActiveAdData, setActiveAdData] = useState([]);

  // FastMoving Item
  const [alltopsellingproudcts, setalltopsellingproudcts] = useState([]);

  // Company data
  const [allcompanydata, setallcompanydata] = useState([]);
  const [allcompanydata2, setallcompanydata2] = useState({});

  const [mailSent, setMailSent] = useState(false);
  const [notWorking, setnotWorking] = useState(false);

  const [modal10, setModal10] = useState(false);

  const [textareaValue, settextareaValue] = useState('');

  useEffect(() => {
    GetActiveCompanyAd();
    Getalltopsellingproducts();
    GetAllCompanyData();
    Getdashboarddata();
  }, []);

  const GetActiveCompanyAd = async () => {
    setOpenLoader(true);
    await axios.instance
      .get(
        `GetActiveCompanyAd/${sessionStorage.getItem(
          'Companyid',
        )}/${sessionStorage.getItem('combranch')}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(res => {
        setActiveAdData(res.data);
        setOpenLoader(false);
      });
  };

  const toggle10 = () => {
    if (modal10) {
      setModal10(false);
      settextareaValue('');
    } else {
      setModal10(true);
    }
  };

  // Fastmoving item
  const Getalltopsellingproducts = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`/Gettopsellingproducts/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        //////console.log(res.data)

        setalltopsellingproudcts(res.data);
      });
  };

  // Company data
  const GetAllCompanyData = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`/GetOneCompanyData/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        setallcompanydata(res.data);
        setallcompanydata2(res.data[0]);
      });
  };
  const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );

  const nameStyle = {
    fontWeight: 'bold',
    fontSize: '1.5em',
    color: '#333',
  };

  const addressStyle = {
    marginTop: '10px',
    lineHeight: '1.5em',
    color: '#555',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    aliignContent: 'center',
    flexDirection: 'column',
  };

  // const mailCus = async () => {
  //   setOpenLoader(true);
  //   await axios.instance
  //     .post(
  //       `mailForCustomer/${sessionStorage.getItem(
  //         'Companyid',
  //       )}/${sessionStorage.getItem('Customer_Log')}`,
  //       {
  //         emailContent: textareaValue,
  //       },
  //     )
  //     .then(res => {
  //       console.log(res.data);
  //       if (res.data === 'Email sent successfully') {
  //         setMailSent(true);
  //         toggle10();
  //         // handleCloseAccess()
  //       } else {
  //         setnotWorking(true);
  //       }
  //       // GetAllCustomerAccess();
  //       setOpenLoader(false);
  //     });
  // };

  const [error, setError] = useState(false);

  const mailCus = async () => {
    if (!textareaValue) {
      setError(true);
      return;
    }

    setError(false);
    setOpenLoader(true);

    try {
      const res = await axios.instance.post(
        `mailForCustomer/${sessionStorage.getItem(
          'Companyid',
        )}/${sessionStorage.getItem('Customer_Log')}`,
        {
          emailContent: textareaValue,
        },
      );

      console.log(res.data);

      if (res.data === 'Email sent successfully') {
        setMailSent(true);
        toggle10();
      } else {
        setnotWorking(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setOpenLoader(false);
    }
  };

  const Getdashboarddata = () => {
    // document.getElementById('card213').className = 'card133bd';

    const token = sessionStorage.getItem('AuthToken');
    const customerid = sessionStorage.getItem('Customer_Log');
    ////console.log(customerid)
    const getdash = axios.instance
      .get(`/Cus/${customerid}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      })
      .then(res => {
        for (const data of res.data) {
          sessionStorage.setItem('Companyid', data.Company_Id);
          sessionStorage.setItem('combranch', data.combranch);
          sessionStorage.setItem('StateId', data.StateId);
          sessionStorage.setItem('Statename', data.State);
          sessionStorage.setItem('StateCode', data.StateCode);
          sessionStorage.setItem('COMPANY_STATECODE', data.COMPANY_STATECODE);
          sessionStorage.setItem('IGSTApplicable', data.IGSTApplicable);
          sessionStorage.setItem('RegisterType', data.RegisterType);

          //console.log('test', data.StateCode)
        }
      });
  };

  return (
    <div>
      <div>
        <div>
          <Container fluid={true}>
            <h6 className="titleviewinspection">Dashboard </h6>
            <Card className="pb-5">
              <CardBody>
                <Row>
                  <Col lg="12" className="my-2">
                    <div
                      style={{
                        boxShadow:
                          'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
                      }}
                    >
                      {ActiveAdData.map(data =>
                        data.Ads_Image !== '' ? (
                          <img
                            key={data.Ads_Image}
                            src={`${axios.baseURL}AdsBannerImage/${data.Ads_Image}`}
                            alt="Ad Banner"
                            style={{
                              width: '100%',
                              maxHeight: '100px',
                              objectFit: 'contain',
                            }}
                          />
                        ) : null,
                      )}
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <DashboardOld />
                  </Col>
                  {/* Client Requirement to hide this */}
                  {/*
                  <Col lg="12" className="my-2">
                    
                     <div className="w-100">
                      <a
                        href="https://www.gst.gov.in/newsandupdates"
                        target="_blank"
                      >
                        <button className="btnGSt">
                          <i className="animationgst"></i>Check GST Updates
                          <i className="animation"></i>
                        </button>
                      </a>
                    </div> 

                    {/* <a
                      href="https://www.gst.gov.in/newsandupdates"
                      target="_blank"
                    >
                      <Button
                        size="large"
                        variant="contained"
                        color="success"
                        fullWidth
                      >
                        Check GST Updates
                      </Button>
                    </a> 
                  </Col>
                  */}

                  {/* <Col lg="4" className="my-2">
                    <Zoom
                      in={true}
                      style={{ transitionDelay: true ? '400ms' : '0ms' }}
                    >
                      <Card
                        style={{
                          borderRadius: '8px',
                          backgroundColor: 'white',
                        }}
                        className="border-none text-white-50"
                      >
                        <CardBody
                          style={{
                            color: '#4b4c4d',
                            backgroundColor: 'ghostwhite',
                            padding: 0,
                            margin: '3px',
                            borderRadius: '8px',
                            boxShadow:
                              'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                          }}
                        >
                          <h5
                            className="m-0 font-size-30 "
                            style={{
                              fontWeight: 'bold',
                              color: 'white',
                              letterSpacing: '1px',
                              padding: '20px',
                              background: '#dd3e54',
                              background:
                                ' -webkit-linear-gradient(to right, #6be585, #dd3e54)',
                              background:
                                'linear-gradient(to right, #6be585, #dd3e54)',
                              borderTopLeftRadius: 11,
                              borderTopRightRadius: 11,
                            }}
                          >
                            <ReportGmailerrorredIcon
                              style={{
                                fontSize: '25px',
                                color: 'white',
                                marginRight: '2px',
                              }}
                            />
                            Top Moving Products
                          </h5>
                          <CardText className="font-size-12 mt-2 p-0 ">
                            <div
                              className="table-container"
                              style={{
                                minHeight: '524px',
                                maxHeight: '524px',
                                overflowY: 'scroll',
                              }}
                            >
                              <Table className="table-centered table-nowrap mb-0">
                                <tbody>
                                  {alltopsellingproudcts.map((data, index) => (
                                    <tr key={index}>
                                      <td>
                                        <Typography
                                          variant="subtitle2"
                                          color="#007F73"
                                        >
                                          {data.Product_Details_Description}
                                        </Typography>
                                        {/* <p className="text-bold font-size-13 mb-0">
                                          {`Brand: ${data.Brand}`}
                                        </p> 
                                        
                                      </td>
                                      {/* 
                                      <td className="text-muted fw-semibold text-end">
                                        {numeral(data.Net_quantity).format(
                                          '0.00',
                                        )}
                                      </td> 
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </CardText>
                        </CardBody>
                      </Card>
                    </Zoom>
                  </Col>

                  <Col lg="8" className="my-2">
                    <Zoom
                      in={true}
                      style={{ transitionDelay: true ? '400ms' : '0ms' }}
                    >
                      <Card
                        style={{
                          borderRadius: '8px',
                          backgroundColor: 'white',
                        }}
                        className="border-none text-white-50"
                      >
                        <CardBody
                          style={{
                            color: '#4b4c4d',
                            backgroundColor: 'ghostwhite',
                            padding: 0,
                            margin: '3px',
                            borderRadius: '8px',
                            boxShadow:
                              'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                          }}
                        >
                          <h5
                            className="m-0 font-size-30 mb-3 "
                            style={{
                              fontWeight: 'bold',
                              color: 'white',
                              letterSpacing: '1px',
                              padding: '20px',
                              background: '#009FFF',
                              background:
                                '-webkit-linear-gradient(to right, #ec2F4B, #009FFF)',
                              background:
                                'linear-gradient(to right, #ec2F4B, #009FFF)',
                              borderTopLeftRadius: 11,
                              borderTopRightRadius: 11,
                            }}
                          >
                            <EventAvailableIcon
                              style={{
                                fontSize: '25px',
                                color: 'white',
                                marginRight: '2px',
                              }}
                            />
                            Work Planner
                          </h5>{' '}
                          <CardText className="font-size-12 mt-2 p-0 ">
                            <div
                              style={{
                                minHeight: '516px',
                                maxHeight: '516px',
                                overflowY: 'scroll',
                              }}
                            >
                              <MyCalendar />
                            </div>
                          </CardText>
                        </CardBody>
                      </Card>
                    </Zoom>
                  </Col> */}

                  <Col lg="12" className="my-2">
                    <Zoom
                      in={true}
                      style={{ transitionDelay: true ? '400ms' : '0ms' }}
                    >
                      <Card
                        style={{
                          borderRadius: '8px',
                          backgroundColor: 'white',
                        }}
                        className="border-none text-white-50"
                      >
                        <CardBody
                          style={{
                            color: '#4b4c4d',
                            backgroundColor: 'ghostwhite',
                            padding: 0,
                            margin: '3px',
                            borderRadius: '8px',
                            boxShadow:
                              'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                          }}
                        >
                          <h5
                            className="m-0 font-size-30 mb-3 "
                            style={{
                              fontWeight: 'bold',
                              color: 'white',
                              letterSpacing: '1px',
                              padding: '20px',

                              background: '#373B44',
                              background:
                                '-webkit-linear-gradient(to right, #4286f4, #373B44)',
                              background:
                                'linear-gradient(to right, #4286f4, #373B44)',
                              borderTopLeftRadius: 11,
                              borderTopRightRadius: 11,
                            }}
                          >
                            <ApartmentIcon
                              style={{
                                fontSize: '25px',
                                color: 'white',
                                marginRight: '2px',
                              }}
                            />
                            Company Details
                          </h5>

                          <Row>
                            <Col lg="7">
                              <Row className="m-2">
                                <Col lg="1">
                                  <img
                                    alt="text ad"
                                    className=""
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      objectFit: 'contain',
                                    }}
                                    src={iconsimage}
                                  />
                                </Col>
                                <Col lg="11">
                                  <Stack fullWidth className="w-100">
                                    {allcompanydata.map((data, index) => (
                                      <div
                                        key={index}
                                        style={{ fontSize: '12px' }}
                                        className="w-100"
                                      >
                                        <Item>
                                          <b>{data.Company_Name}</b>
                                        </Item>
                                        <Item>
                                          {`${data.Address1} ${data.Address2}`}
                                        </Item>
                                        <Item>
                                          {data.City}&nbsp;{data.State} &nbsp;
                                          {data.Zip_Code}
                                        </Item>
                                        <Item>{data.Country}</Item>
                                        <Item>GSTIN : &nbsp;{data.TIN_No}</Item>
                                      </div>
                                    ))}
                                  </Stack>
                                </Col>
                              </Row>
                            </Col>
                            <Col lg="5">
                              <div
                                style={{ borderLeft: '1px solid #6295A2' }}
                                className="w-100 d-flex justify-content-start flex-column align-items-center gap-2 pl-2 my-2"
                              >
                                <Row>
                                  <Col lg="12">
                                    <Divider>
                                      <Chip
                                        label="Contact Person"
                                        size="small"
                                        color="success"
                                        variant="outlined"
                                      />
                                    </Divider>
                                    <Row>
                                      <Col
                                        lg="2"
                                        className="d-flex justify-content-center align-items-center gap-2"
                                      >
                                        <img
                                          alt="text ad"
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                            objectFit: 'contain',
                                          }}
                                          src={cnt}
                                        />
                                      </Col>
                                      <Col
                                        lg="8"
                                        className="d-flex flex-column justify-content-center align-items-start gap-2"
                                      >
                                        {allcompanydata.map((data, index) => (
                                          <>
                                            <div style={{ fontSize: '12px' }}>
                                              {data.Contact_Person}
                                            </div>

                                            <div style={{ fontSize: '12px' }}>
                                              {data.EmailId}
                                            </div>
                                          </>
                                        ))}
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col lg="12">
                                    <Button
                                      fullWidth
                                      className="my-2"
                                      variant="outlined"
                                      color="success"
                                      size="small"
                                      onClick={() => {
                                        toggle10();
                                      }}
                                      endIcon={<ForwardToInboxIcon />}
                                    >
                                      Send Enquiry
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Zoom>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
          <Modal isOpen={modal10} toggle={toggle10} size="lg">
            <ModalBody>
              <Typography variant="subtitle2" color="#41B06E">
                <span style={{ color: 'black', fontWeight: 'normal' }}>
                  Mail To:
                </span>
                <br />
                {allcompanydata2.EmailId}
              </Typography>

              <TextField
                mt={2}
                sx={{ mt: 2 }}
                id="outlined-multiline-static"
                label="Message"
                multiline
                fullWidth
                rows={4}
                defaultValue="Type Something Here"
                value={textareaValue}
                onChange={e => {
                  settextareaValue(e.target.value);
                }}
                error={error}
                helperText={error ? 'please type something...' : ''}
              />

              <div className="text-center my-2">
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={() => {
                    mailCus();
                  }}
                >
                  Send
                </Button>{' '}
                <Button
                  color="warning"
                  size="small"
                  variant="outlined"
                  onClick={toggle10}
                >
                  Cancel
                </Button>
              </div>
            </ModalBody>
          </Modal>
          {mailSent ? (
            <SweetAlert
              title="Your Enquiry Has been Sent"
              timeout={3000}
              style={{
                position: 'absolute',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              showCloseButton={false}
              showConfirm={false}
              success
              onConfirm={() => {
                setMailSent(false);
              }}
            >
              {' '}
            </SweetAlert>
          ) : null}
          {notWorking ? (
            <SweetAlert
              title=" Unable To Process"
              timeout={2000}
              style={{
                position: 'absolute',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              showCloseButton={false}
              showConfirm={false}
              error
              onConfirm={() => {
                setnotWorking(false);
              }}
            >
              {' '}
            </SweetAlert>
          ) : null}
        </div>
      </div>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </div>
  );
}

export default Dashboard;
